import React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Button } from '@material-ui/core';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { useHistory } from 'react-router-dom';
import { useAppState } from '../../../state';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      background: theme.brand,
      color: 'white',
      borderRadius: 50,
      '&:hover': {
        background: '#600101',
      },
    },
  })
);

export default function EndCallButton(props: { className?: string }) {
  const classes = useStyles();
  const { room } = useVideoContext();
  const history = useHistory()
  const { user_type, closeRoom } = useAppState()

  const onDisconnect = () => {
    if(user_type === 'host') {
      closeRoom(room!.sid).then(res=> console.log(res));
    }
    room!.disconnect(); 
    history.push('/')
  }

  return (
    <Button onClick={onDisconnect} className={clsx(classes.button, props.className)} data-cy-disconnect>
      Disconnect
    </Button>
  );
}
